'use client';

import { Link2 } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@naumu/ui/components/button';
import { XLogo } from '@/modules/docs/components/x-logo';

export interface DocsPageShareProps {
	title: string;
	path: string;
}

export function DocsPageShare({ title, path }: DocsPageShareProps) {
	const buildUrl = () => {
		const origin = typeof window !== 'undefined' ? window.location.origin : '';
		return origin + path;
	};

	const handleCopyLink = async () => {
		await navigator.clipboard.writeText(buildUrl());
		toast.success('Link copied to clipboard');
	};

	const handleShareOnX = () => {
		window.open(
			'https://x.com/intent/tweet?text=' +
				encodeURIComponent(title) +
				'&url=' +
				encodeURIComponent(buildUrl()),
			'_blank',
			'noopener,noreferrer'
		);
	};

	return (
		<div className="flex items-center gap-1">
			<Button
				variant="ghost"
				size="sm"
				iconOnly
				aria-label="Copy link"
				onClick={handleCopyLink}
			>
				<Link2 className="size-4" />
			</Button>
			<Button
				variant="ghost"
				size="sm"
				iconOnly
				aria-label="Share on X"
				onClick={handleShareOnX}
			>
				<XLogo className="size-4" />
			</Button>
		</div>
	);
}
